import Poll, { PollTickHandler } from '../Poll';

export default class SimpleTracker {
  private active = false;

  private poll: Poll | null = null;

  private trackFn: PollTickHandler | null = null;

  constructor() {
    this.poll = new Poll(this.trackEvent.bind(this));
  }

  /**
   * Activates the tracker and the poll and sets the visibility change listener,
   * to determine if the polling must be stopped when the browser's tab loses focus.
   */
  public attach(trackFn: PollTickHandler) {
    this.trackFn = trackFn;
  }

  /**
   * Disables the tracker and detaches the polling to avoid duplicated
   * trackings if the implementor component is destroyed.
   */
  public detach() {
    this.setActive(false);
    this.poll?.detach();
  }

  /**
   * Enables or disables the tracker by pausing/resuming the polling. This
   * is useful if we wish to track conditionally, for example, only when the
   * target is within the user's viewport.
   */
  public setActive(active: boolean) {
    this.active = active;

    if (!this.active) {
      this.poll?.pause();
    } else {
      this.poll?.resume();
    }
  }

  private trackEvent(elapsedTime: number) {
    if (this.trackFn) {
      this.trackFn(elapsedTime);
    }
  }
}
